import { GET, POST } from './executer';
import { tioApiServiceInstance } from './apiService';

interface SignInParams {
  email: string;
  password: string;
  recaptchaToken: string;
}

interface SignInResponse {
  token: string;
}

interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  name: string; // Full name for display
  accountId?: string;
  role: string; // User role: 'root', 'account-admin', 'collaborator', 'developer', 'viewer', etc.
  team?: string | null; // Team ID from teams table
  teamDisplayName?: string | null; // Team display name (cached from login)
  phoneNumber?: string;
}

interface MeParams {
  token: string;
}

interface MeResponse {
  user: User;
}

class AuthService {
  async signIn({ email, password, recaptchaToken }: SignInParams) {
    return await tioApiServiceInstance.client.execute<SignInResponse>(
      POST,
      'auth/sign-in',
      {
        email,
        password,
        recaptchaToken,
      }
    );
  }

  async me({ token }: MeParams) {
    return await tioApiServiceInstance.client.execute<MeResponse>(
      GET,
      'users/me',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
export type { User, SignInResponse, MeResponse };

